// src/components/Filter/Actions/ClearAllAction.ts
import { ClearFiltersParams } from './types';
import { createEmptyFilters } from 'src/components/Filter/Utils/FilterUtils';

export const clearAllAction = async ({
  state,
  actions,
  uiState,
  gridRef,
  dataCache,
}: ClearFiltersParams): Promise<void> => {
  const { filters, distinctValues, defaultFilterOptions } = state;

  const { setFilters, setActiveFilters, setAgGridFilters, setDistinctValues, fetchData } = actions;

  const { setIsLoading, setHasFilterChanges, setFiltersApplied } = uiState;

  const grid = typeof gridRef === 'function' ? null : gridRef?.current;

  try {
    setIsLoading(true);

    const emptyFilters = createEmptyFilters(defaultFilterOptions);
    setFilters(emptyFilters);
    setActiveFilters(emptyFilters);
    setAgGridFilters({});
    setHasFilterChanges(false);

    if (grid?.resetFilters) {
      grid.resetFilters();
    }

    await fetchData({});

    setDistinctValues((prev) => ({
      ...prev,
      ...distinctValues,
    }));

    setFiltersApplied(false);
    setTimeout(() => setFiltersApplied(true), 0);

    // Update grid API handling
    if (grid) {
      if ('setFilterModel' in grid && typeof grid.setFilterModel === 'function') {
        grid.setFilterModel({});
      }
      if ('refreshCells' in grid && typeof grid.refreshCells === 'function') {
        grid.refreshCells({ force: true });
      }
    }

    dataCache.clear();
  } catch (error) {
    console.error('Error clearing filters:', error);
    throw new Error('Failed to clear filters');
  } finally {
    setIsLoading(false);
  }
};
